import { db } from "./db";

export const DEMO_SEEDED_KEY = "demo:seeded:v1";

/** Record an explicit first-run decision not to install demo content. */
export async function markDemoSeedSkipped(): Promise<void> {
  await db.kv.put({
    id: DEMO_SEEDED_KEY,
    value: { at: Date.now(), skipped: "onboarding" },
  });
}
